import initReactApp from 'dpl/util/initReactApp';
import UserAuthApp from 'dpl/UserAuth/components/Routes';
import UserAuthHeaderLink from 'dpl/UserAuth/components/UserAuthHeaderLink';

initReactApp({
  UserAuthApp,
  UserAuthHeaderLink
});
